import { render, staticRenderFns } from "./DetailSample.vue?vue&type=template&id=59a988eb"
import script from "./DetailSample.vue?vue&type=script&lang=js"
export * from "./DetailSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports